module.exports = __webpack_public_path__ + "static/img/empty-light.b090acd9.png";